import { DateTime, Info, Settings } from 'luxon';
export var E_DATE_TYPE;
(function (E_DATE_TYPE) {
    E_DATE_TYPE["DATE"] = "date";
    E_DATE_TYPE["SINCE"] = "time-left";
    E_DATE_TYPE["ACCURATE_DATE"] = "accurate-date";
})(E_DATE_TYPE || (E_DATE_TYPE = {}));
export var E_DATE_FORMAT;
(function (E_DATE_FORMAT) {
    E_DATE_FORMAT[E_DATE_FORMAT["DATE"] = DateTime.DATE_SHORT] = "DATE";
    E_DATE_FORMAT[E_DATE_FORMAT["ACCURATE_DATE"] = DateTime.DATETIME_SHORT] = "ACCURATE_DATE";
})(E_DATE_FORMAT || (E_DATE_FORMAT = {}));
export var getNow = function () {
    return DateTime.now();
};
export var parseISOToDate = function (ISODate) {
    return DateTime.fromISO(ISODate);
};
export var parseISOToMillis = function (ISODate) {
    try {
        return DateTime.fromISO(ISODate).toMillis();
    }
    catch (e) {
        console.error('Invalid ISO format');
    }
};
var parseISOToSince = function (ISODate) {
    var ISOToMilli = DateTime.fromISO(ISODate).toMillis();
    var now = DateTime.now();
    var diffFromNow = Math.floor((now - ISOToMilli) / 1000 / 60);
    if (diffFromNow === 0) {
        return '< 1min';
    }
    else if (diffFromNow < 60) {
        return "".concat(diffFromNow, "min");
    }
    else if (diffFromNow >= 60) {
        var sinceHour = Math.floor(diffFromNow / 60);
        if (sinceHour < 24) {
            return "".concat(sinceHour, "h");
        }
        else {
            var diffDay = Math.floor(sinceHour / 24);
            var restOfHour = sinceHour % 24;
            return "".concat(diffDay, "d ").concat(restOfHour, "h");
        }
    }
    return ISODate;
};
export var convertToDate = function (type, ISODate) {
    if (!ISODate) {
        return null;
    }
    switch (type) {
        case E_DATE_TYPE.DATE: {
            return DateTime.fromISO(ISODate).toLocaleString(E_DATE_FORMAT.DATE);
        }
        case E_DATE_TYPE.ACCURATE_DATE: {
            return DateTime.fromISO(ISODate).toLocaleString(E_DATE_FORMAT.ACCURATE_DATE);
        }
        case E_DATE_TYPE.SINCE: {
            return parseISOToSince(ISODate);
        }
        default: {
            try {
                return DateTime.fromISO(ISODate).toFormat(type);
            }
            catch (e) {
                // thrown error ?
            }
            // thrown error ?
            return null;
        }
    }
};
export var nowParsedString = function () {
    return DateTime.now().toLocaleString(E_DATE_FORMAT.ACCURATE_DATE);
};
export var getPreviousMonth = function () {
    var now = DateTime.local();
    return DateTime.local().minus({ months: 1 }).monthLong;
};
export var getCurrentMonth = function () {
    var now = DateTime.local();
    return DateTime.local(now.year, now.month, now.day).monthLong;
};
export var getCurrentYear = function () {
    return DateTime.local().year;
};
export var parseYYYYMMDDToDate = function (date) {
    return date ? DateTime.fromFormat(date, 'yyyy-MM-dd') : null;
};
export var updateDate = function (date, values) {
    return date.set(values);
};
export var getAllMonths = function () {
    return Info.months('long');
};
export var setDefaultDateLocale = function (locale) {
    Settings.defaultLocale = locale;
};
